var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`rounded-${_vm.rounded}`,staticStyle:{"position":"relative"},style:({
    backgroundImage: `url(${_vm.cover})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  })},[_c('v-skeleton-loader',{class:`rounded-${_vm.rounded}`,staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","z-index":"0"},style:({
      backgroundColor: _vm.cover ? 'rgba(0, 0, 0, 0.4)' : undefined,
    }),attrs:{"type":"image"}}),_c('div',{ref:"videoBackground",class:`rounded-${_vm.rounded}`,staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"data-vbg":_vm.src}}),_c('div',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }